import _ from 'lodash'
import $ from 'jquery'
import { DirectiveOptions, VNode, VNodeDirective } from 'vue'

/**
 * エスケープキーを押したときに関数を実行するディレクティブ。
 */
const options: DirectiveOptions = {
  bind(el: HTMLElement, binding: VNodeDirective, vnode: VNode, oldVnode: VNode) {
    const handler = (event: KeyboardEvent) => {
      if (event.keyCode !== 27) {
        return
      }
      if (!_.isFunction(binding.value)) {
        console.error(`v-${binding.name} の引数には、関数を指定してください。`)
      }
      binding.value()
    }
    $(el).data('cm.escape-key', handler)
    document.addEventListener('keydown', handler)
  },
  unbind(el: HTMLElement, binding: VNodeDirective, vnode: VNode, oldVnode: VNode) {
    document.removeEventListener('keydown', $(el).data('cm.escape-key'))
    $(el).removeData('cm.escape-key')
  }
}

export default options
